import React from "react";
import { SUB_DIRECTORY } from "../../common/constant";

const Blog = () => {



    return (
        <>
            <div className="mt-3">
                <span className="fw-bold">Blog</span>
                <div className="card mt-2 shadow">
                    <div className="card-body px-2">
                        <div className="row py-2" onClick={() => {
                            window.open('https://www.pincinsurance.com/blog/things-to-consider-while-buying-car-insurance', '_blank')

                        }}
                            style={{ cursor: 'pointer' }}

                        >
                            <div className="col-4 col-md-3">
                                <img
                                    src={`${SUB_DIRECTORY}/assets/images/things_to_consider_while_buying_car_ins.png`}
                                    className="img-fluid rounded shadow"
                                    alt=""
                                />
                            </div>
                            <div className="col">
                                <p className="mb-0 mb-lg-1 blog-title">
                                    Things to Consider When Buying Car Insurance in India
                                </p>
                                {/* <span className="blog-date">09-Aug-2022</span> */}
                            </div>
                        </div>
                        <div className="row py-2 border-top" onClick={() => {
                            window.open('https://www.pincinsurance.com/blog/how-to-transfer-car-insurance', '_blank')

                        }}
                            style={{ cursor: 'pointer' }}

                        >
                            <div className="col-4 col-md-3">
                                <img
                                    src={`${SUB_DIRECTORY}/assets/images/how_to_transfer_car_ins.png`}
                                    className="img-fluid rounded shadow"
                                    alt=""
                                />
                            </div>
                            <div className="col">
                                <p className="mb-0 mb-lg-1 blog-title">
                                    How to Transfer Car Insurance
                                </p>
                                {/* <span className="blog-date">09-Aug-2022</span> */}
                            </div>
                        </div>
                        <div className="row py-2 border-top" onClick={() => {
                            window.open('https://www.pincinsurance.com/blog/how-to-check-vehicle-insurance-status-online', '_blank')

                        }}
                            style={{ cursor: 'pointer' }}

                        >
                            <div className="col-4 col-md-3">
                                <img
                                    src={`${SUB_DIRECTORY}/assets/images/check_vehicle_ins_status_online.png`}
                                    className="img-fluid rounded shadow"
                                    alt=""
                                />
                            </div>
                            <div className="col">
                                <p className="mb-0 mb-lg-1 blog-title">
                                    How to check vehicle insurance status online
                                </p>
                                {/* <span className="blog-date">09-Aug-2022</span> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Blog;